module.exports = __webpack_public_path__ + "static/media/boss-bar-red-01.c7706104.png";